import AnalyticsWebClient, { envType, userType } from '@atlassiansox/analytics-web-client'
import { isParamValid } from '../util'

function getLocale() {
  if (window.navigator.languages !== undefined) return navigator.languages[0]

  return window.navigator.language
}

const analytics = {
  context: {},
  events: {},
}

let anonymousId

if (typeof window !== 'undefined') {
  const urlParams = new URLSearchParams(window.location.search)

  analytics.context = {
    aaid: urlParams.get('aaid'),
    aid: urlParams.get('aid'),
    source: urlParams.get('s'),
  }

  window.history.replaceState(null, '', window.location.pathname)

  const client = new AnalyticsWebClient(
    {
      env:
        {
          ddev: envType.DEV,
          'stg-east': envType.STAGING,
          'prod-east': envType.PROD,
        }[process.env.GATSBY_DEPLOYMENT_ENVIRONMENT] || envType.LOCAL, // required
      product: 'externalProductIntegrations', // required
      subproduct: 'piLanding',
      version:
        process.env.GATSBY_BUILD_NUMBER &&
        `atlassian-integrations@${process.env.GATSBY_BUILD_NUMBER}`,
      locale: getLocale(),
    },
    { useLegacyUrl: true },
  )

  if (isParamValid(analytics.context.aaid)) {
    client.setUserInfo(userType.ATLASSIAN_ACCOUNT, analytics.context.aaid)
  }

  if (isParamValid(analytics.context.aid)) {
    anonymousId = analytics.context.aid
  }

  analytics.events = {
    atlLinkClick(linkName) {
      // https://data-portal.us-east-1.prod.public.atl-paas.net/analytics/registry/23331
      return client.sendUIEvent({
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'atlassianRelatedLink',
        anonymousId,
        attributes: {
          source: analytics.context.source,
          linkName,
        },
        source: 'piLanding',
      })
    },
    appLinkClick(appName) {
      // https://data-portal.us-east-1.prod.public.atl-paas.net/analytics/registry/23332
      return client.sendUIEvent({
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'install',
        anonymousId,
        attributes: {
          appName,
          source: analytics.context.source,
        },
        source: 'piLanding',
      })
    },
    modal: {
      buttons: {
        makeSuggestionClick() {
          // https://data-portal.us-east-1.prod.public.atl-paas.net/analytics/registry/25011
          return client.sendUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'makeSuggestionButton',
            anonymousId,
            attributes: {
              source: analytics.context.source,
            },
            source: 'piLanding',
          })
        },
        submitClicked() {
          // https://data-portal.us-east-1.prod.public.atl-paas.net/analytics/registry/25012
          return client.sendUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'suggestionSubmissionButton',
            anonymousId,
            attributes: {
              source: analytics.context.source,
            },
            source: 'piLanding',
          })
        },
      },
      // https://data-portal.us-east-1.prod.public.atl-paas.net/analytics/registry/25013
      form: {
        submissionSucceeded() {
          return client.sendTrackEvent({
            action: 'submitted',
            actionSubject: 'integrationSuggestionSubmission',
            anonymousId,
            attributes: {
              source: analytics.context.source,
              status: 'succeeded',
            },
            source: 'piLanding',
          })
        },
        submissionFailed() {
          return client.sendTrackEvent({
            action: 'submitted',
            actionSubject: 'integrationSuggestionSubmission',
            anonymousId,
            attributes: {
              source: analytics.context.source,
              status: 'failed',
            },
            source: 'piLanding',
          })
        },
      },
    },
    viewed() {
      // https://data-portal.us-east-1.prod.public.atl-paas.net/analytics/registry/23330
      return client.sendScreenEvent({
        anonymousId,
        attributes: { source: analytics.context.source, pathname: window.location.pathname },
        name: 'piLanding',
      })
    },
    // General form events. Please use it along with formId
    form: {
      submitted({ formId, succeeded }) {
        if (!formId || !succeeded) {
          throw new Error(`'formId' and 'succeeded' parameters are required`)
        }

        // https://data-portal.internal.atlassian.com/analytics/registry/29925
        return client.sendTrackEvent({
          action: 'submitted',
          actionSubject: 'form',
          anonymousId,
          attributes: {
            source: analytics.context.source,
            formId,
            status: succeeded ? 'succeeded' : 'failed',
          },
          source: 'piLanding',
        })
      },
      submitClicked({ formId }) {
        if (!formId) {
          throw new Error(`'formId' and 'succeeded' parameters are required`)
        }

        // https://data-portal.internal.atlassian.com/analytics/registry/29926
        return client.sendUIEvent({
          action: 'clicked',
          actionSubject: 'button',
          actionSubjectId: 'submitForm',
          anonymousId,
          attributes: {
            source: analytics.context.source,
            formId,
          },
          source: 'piLanding',
        })
      },
    },
  }
}

export default analytics
